<template>
	<div v-if="single" :id="attributeName + '__area'">
		<div data-attribute-type="single" :class="getColumnClass()" data-attribute-index="0">
			<div :class="SINGLE_ATTRIBUTE">
				<div class="col-sm-5">
					<AttributeLabel
						:attributeName="attributeName"
						:localizedTitle="localizedTitle"
						:is-primary="isPrimary"
						:is-multiple="isMultiple"
						:max-count="maxCount"
						:sl-attribute="false"
						:locked-edit="lockedEdit"
						:enable-copy-attribute-name="enableCopyAttributeName"
					/>
				</div>
				<div class="col-sm-7">
					<input type="text" :id="attributeName"
						   :class="'textInput datepicker attribute-editor ' + getDefaultValueWithLockClasses()"
						   :value="attributeValue"
						   :disabled="lockedEdit">
					<button v-if="!lockedEdit"
							:class="'button_reset fa fa-times ' + getDefaultValueWithLockClasses()"></button>
				</div>
			</div>
		</div>
	</div>
	<div v-else data-attribute-type="single" :class="getColumnClass()" data-attribute-index="0">
		<div :class="SINGLE_ATTRIBUTE">
			<input type="text" :id="attributeName + '__0'"
				   :class="'textInput datepicker attribute-editor multiple-hotkey ' + getDefaultValueWithLockClasses()"
				   :value="attributeValue">
			<button :class="'button_reset fa fa-times ' + getDefaultValueWithLockClasses()"></button>
			<button class="button_minus fa fa-minus" tabindex="-1"></button>
		</div>
	</div>
</template>

<script>
import AttributeLabel from './AttributeLabel'
import defaultClassManager from '../../mixins/defaultClassManager'

export default {
	components: {
		AttributeLabel
	},
	mixins: [defaultClassManager],
	name: 'DAttributeEditorComponent',
	props: [
		'attributeName',
		'localizedTitle',
		'isMultiple',
		'isPrimary',
		'maxCount',
		'defaultValue',
		'defaultLock',
		'colspan',
		'enableCopyAttributeName',
		'itemData',
		'lockedEdit'
	],
	data () {
		return {
			single: !this.isMultiple,
			SINGLE_ATTRIBUTE: 'single-attribute'
		}
	},
	computed: {
		attributeValue: function () {
			if (this.itemData) {
				return this.itemData.slice(0, 10)
			} else if (this.defaultValue) {
				return this.defaultValue
			} else {
				return ''
			}
		}
	}
}
</script>

<style scoped>

</style>
